import { useState, useEffect } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    contactSubject: '',
    contactMessage: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitUrl, setSubmitUrl] = useState('');

  useEffect(() => {
    const fetchFormUrl = async () => {
      try {
        const response = await fetch('https://readdy.ai/api/public/form/submit-addr?formId=contact-form');
        const data = await response.json();
        if (data.submitAddr) {
          setSubmitUrl(data.submitAddr);
        }
      } catch (error) {
        console.error('Failed to fetch form URL:', error);
      }
    };
    fetchFormUrl();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!submitUrl || isSubmitting) return;

    setIsSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          contactName: '',
          contactPhone: '',
          contactEmail: '',
          contactSubject: '',
          contactMessage: ''
        });
        setTimeout(() => setShowSuccess(false), 3000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const contactInfo = [
    {
      icon: 'fa-phone',
      title: '대표전화',
      content: '041-585-3337'
    },
    {
      icon: 'fa-envelope',
      title: '이메일',
      content: 'wjsxodn12@logiview.co.kr'
    },
    {
      icon: 'fa-clock',
      title: '운영시간',
      content: '평일 09:00 - 18:00'
    },
    {
      icon: 'fa-map-marker-alt',
      title: '천안센터',
      content: '충청남도 천안시 서북구 성환읍 지족향길 10'
    },
    {
      icon: 'fa-map-marker-alt',
      title: '안성센터',
      content: '경기도 안성시 양성면 이현배티길 42-12 4F'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <p className="text-cyan-600 font-semibold mb-2 tracking-wider text-sm">CONTACT US</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">문의하기</h2>
            <p className="text-gray-600 text-lg mb-10">물류 고민, 로지뷰가 해결해 드립니다</p>

            <div className="space-y-6 mb-10">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center">
                    <i className={`fas ${info.icon} text-cyan-600`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">{info.title}</h4>
                    <p className="text-gray-600">{info.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-8 border border-cyan-100 h-fit">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 bg-cyan-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="fas fa-info text-white"></i>
              </div>
              <div>
                <h6 className="font-bold text-gray-900 mb-2">센터 방문 시 사전 예약 필수</h6>
                <p className="text-gray-600 text-sm leading-relaxed">
                  보다 정확한 상담을 위해 방문 전 유선 또는 이메일로 사전 예약을 부탁드립니다.
                  담당자가 고객님의 물류 니즈를 파악하여 맞춤형 솔루션을 제안해 드립니다.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3">
              <a 
                href="#quote-form"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-cyan-600 text-white rounded-lg font-medium hover:bg-cyan-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="fas fa-calendar-check"></i>
                방문 예약하기
              </a>
              <a 
                href="tel:1588-XXXX"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-cyan-600 rounded-lg font-medium border border-cyan-600 hover:bg-cyan-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="fas fa-phone"></i>
                전화 상담
              </a>
              <a 
                href="https://pf.kakao.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-yellow-400 text-gray-900 rounded-lg font-medium hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-kakao-talk-fill text-lg"></i>
                카카오톡 상담
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
